import '../App.css'


export default function LinuxTutorial() {
    return (
      <h1>Linux Tutorial</h1>
    
    );
  }